/**
 * /design (P0-9): the layout of the design gate page. Stage 2: P0-2's session
 * guard runs first (`beforeLoad`), with P0-2's pending and error screens;
 * then the page renders only when `flags.design` in that session's `auth.me`
 * answer is true.
 *
 * The options are checked by route-wiring.test.ts. They are written out
 * here so the code splitter can move `component` (and
 * with it the page and design.css) into this route's chunk; the guards are a
 * small module that loads eagerly.
 */
import { createFileRoute } from '@tanstack/react-router';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import {
  guardDesignSession,
  loadDesignFlag,
  validateDesignSearch,
} from '../../design/route-guards.js';
import { DesignLayout } from '../../design/route-parts.js';

export const Route = createFileRoute('/design')({
  validateSearch: validateDesignSearch,
  beforeLoad: guardDesignSession,
  loader: loadDesignFlag,
  staleTime: Number.POSITIVE_INFINITY,
  pendingMs: 0,
  pendingMinMs: 0,
  pendingComponent: SessionPending,
  errorComponent: SessionError,
  component: DesignLayout,
});
